import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "balance-record-ctn"
};
var _hoisted_2 = {
  key: 1,
  class: "list-content"
};
var _hoisted_3 = {
  class: "record-list_info"
};
var _hoisted_4 = {
  class: "record-list_type"
};
var _hoisted_5 = {
  class: "record-list_time"
};
import { ref } from "vue";
import EmptyListPlaceholder from "@/components/EmptyListPlaceholder.vue";
import { formatDateWithTZ } from "@/utils/format";
import { queryUserBalanceHistory } from "@/api/user";
import { useUserStore } from "@/store/userStore";
import { priceUtil } from "@op/shared";
export default {
  __name: 'AccountBalanceRecord',
  props: {
    changeType: {
      type: String,
      default: "" // '','income','expense'
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var userStore = useUserStore();
    var props = __props;
    var pageNum = ref(1);
    var pageSize = ref(10);
    var loading = ref(false);
    var finished = ref(false);
    var items = ref([]);
    var fetchData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$data, _res$data2, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading.value = true;
              _context.next = 3;
              return queryUserBalanceHistory({
                change_type: props.changeType,
                page_num: pageNum.value,
                page_size: pageSize.value
              });
            case 3:
              res = _context.sent;
              loading.value = false;
              if (res.isOK) {
                data = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || [];
                items.value = items.value.concat(data);
                if (pageNum.value * pageSize.value > ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.total)) {
                  finished.value = true;
                } else {
                  pageNum.value += 1;
                }
              } else {
                finished.value = true;
              }

              // 测试
              // loading.value = true;
              // setTimeout(() => {
              //   items.value = items.value.concat([
              //     {
              //       id: pageNum.value + "0",
              //       change_event_hrf: pageNum.value + "0",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "1",
              //       change_event_hrf: pageNum.value + "1",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "2",
              //       change_event_hrf: pageNum.value + "2",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "3",
              //       change_event_hrf: pageNum.value + "3",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "4",
              //       change_event_hrf: pageNum.value + "4",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "5",
              //       change_event_hrf: pageNum.value + "5",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "6",
              //       change_event_hrf: pageNum.value + "6",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "7",
              //       change_event_hrf: pageNum.value + "7",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "8",
              //       change_event_hrf: pageNum.value + "8",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //     {
              //       id: pageNum.value + "9",
              //       change_event_hrf: pageNum.value + "9",
              //       create_at: new Date().getTime(),
              //       change_value: 100,
              //     },
              //   ]);
              //   pageNum.value += 1;
              //   if (pageNum.value >= 3) {
              //     finished.value = true;
              //   }
              //   loading.value = false;
              // }, 3000);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fetchData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var reset = function reset() {
      finished.value = false;
      items.value = [];
      pageNum.value = 1;
      fetchData();
    };
    __expose({
      reset: reset
    });
    return function (_ctx, _cache) {
      var _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_list, {
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = function ($event) {
          return loading.value = $event;
        }),
        finished: finished.value,
        "loading-text": _ctx.$t('loading'),
        class: "list",
        onLoad: fetchData
      }, {
        default: _withCtx(function () {
          return [finished.value && items.value.length === 0 ? (_openBlock(), _createBlock(EmptyListPlaceholder, {
            key: 0,
            text: _ctx.$t('haveNoBalanceYet'),
            class: "empty"
          }, null, 8, ["text"])) : _createCommentVNode("", true), items.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, function (item, index) {
            return _openBlock(), _createElementBlock("div", {
              key: item.id,
              class: _normalizeClass(["record-list_item", {
                'last-child': index === items.value.length - 1
              }])
            }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, _toDisplayString(item.change_event_hrf), 1), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatDateWithTZ)(item.create_at)), 1)]), _createElementVNode("div", {
              class: _normalizeClass(["record-list_value", [item.change_value > 0 ? 'record-list_value_red' : 'record-list_value_gray']])
            }, _toDisplayString(item.change_value > 0 ? "+" + _unref(priceUtil).formatBaseUnitToShowPrice(item.change_value, _unref(userStore).getWalletCurrency) : _unref(priceUtil).formatBaseUnitToShowPrice(item.change_value, _unref(userStore).getWalletCurrency)), 3)], 2);
          }), 128))])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["loading", "finished", "loading-text"])]);
    };
  }
};